import { saveAs } from "file-saver";
import { toPng, toCanvas } from "html-to-image";
import canvasToImage from 'canvas-to-image';
import { getId, rem, boundsMaker, mutResizeObserver } from "./util.js";

//get elements
let cardPreview = getId("cardPreview");
let cardZoom = getId("cardZoom");
let cardPan = getId("cardPan");
let card = getId("card");
let cardBgCont = getId("cardBgCont");
let cardBgTrans = getId("cardBgTrans");
let cardBg = getId("cardBg");
let cardBgOutline = getId("cardBgOutline");
let cardDetail = getId("cardDetail");
let cardSig = getId("cardSig");
let cardModeToggle0 = getId("cardModeToggle0");
let cardModeToggle1 = getId("cardModeToggle1");
let cardModeToggle2 = getId("cardModeToggle2");
let cardZoomInput = getId("cardZoomInput");
let cardZoomValue = getId("cardZoomValue");
let settingsBgPosX = getId("settingsBgPosX");
let settingsBgPosY = getId("settingsBgPosY");
let settingsBgPosZ = getId("settingsBgPosZ");
let layoutPosX = getId("layoutPosX");
let layoutPosY = getId("layoutPosY");
let sigPosX = getId("sigPosX");
let sigPosY = getId("sigPosY");
let sigAlign = getId("sigAlign");

//pan + zoom
cardPreview.addEventListener("mousedown", prevPanStart);
window.addEventListener("mousemove", prevPan);
window.addEventListener("mouseup", prevPanEnd);
cardPreview.addEventListener("wheel", prevZoom);

//mobile pan
cardPreview.addEventListener("touchstart", prevPanStart);
window.addEventListener("touchmove", prevPan);
window.addEventListener("touchend", prevPanEnd);
window.addEventListener("touchcancel", prevPanEnd);

//mode shift
window.addEventListener("keydown", prevMod);
window.addEventListener("keyup", prevModOff);
cardPreview.addEventListener("mouseenter", function () {
  prevFocus = true;
});
cardPreview.addEventListener("mouseleave", function () {
  prevFocus = false;
});
let prevDefault = 0;
let prevMode = 0; // 0 = pan/zoom, 1 = bg adjustment, 2 = detail adjustment
let prevFocus = false;
let prevMouseDown = false;
let prevMouseDownTarget;
let prevPanX = 0;
let prevPanY = 0;
let prevBgX = 0;
let prevBgY = 0;
//detail + sig
let prevDetailX = rem(4);
let prevDetailY = rem(4);
let prevSigX = card.clientWidth - cardSig.clientWidth - rem(6);
let prevSigY = card.clientHeight - cardSig.clientHeight - rem(6);
let prevSigAlign = 'RIGHT';
// let prevSigInit = false;
//pan zooms
let prevZoomAmt = 0.25;
let prevZoomScale = 4;
let prevZoomInc = 0.125;
let prevZoomMin = 0.125;
let prevZoomMax = 2;
//bg zooms
let prevBgZoomAmt = 1;
let prevBgZoomScale = 1;
let prevBgZoomInc = 0.125;
let prevBgZoomMin = 0.5;
let prevBgZoomMax = 4;
//mobile touch movementX/Y hack
let previousTouch;

prevModeChange(0);
prevPanX = cardZoom.clientWidth / 2 - cardPan.clientWidth / 2;
prevPanY = cardZoom.clientHeight / 2 - cardPan.clientHeight / 2;
cardPan.style.left = prevPanX + "px";
cardPan.style.top = prevPanY + "px";

export function getPrevDetailX() {
  return prevDetailX;
}

export function getPrevDetailY() {
  return prevDetailY;
}

//change mode
export function prevModeChange(mode) {
  // lock
  prevMode = mode;

  // shared defaults
  cardPreview.style.cursor = "default";
  cardBgOutline.style.outline = "none";
  cardBgOutline.style.pointerEvents = 'all';
  cardBgCont.style.overflow = "hidden";
  cardDetail.classList.toggle('card-movebox', false);
  cardSig.classList.toggle('card-movebox', false);

  // mode 2
  if (prevMode == 2) {
    cardDetail.classList.toggle('card-movebox', true);
    cardSig.classList.toggle('card-movebox', true);
    cardModeToggle2.checked = true;
    cardBgOutline.style.pointerEvents = 'none';
  } else {
    cardModeToggle2.checked = false;
  }

  // mode 1
  if (prevMode == 1) {
    cardBgCont.style.overflow = "visible";
    cardBgOutline.style.outline = "4px dashed rgba(255, 255, 255, 0.4)";
    cardPreview.style.cursor = "move";
    cardModeToggle1.checked = true;
  } else {
    cardModeToggle1.checked = false;
  }

  // mode 0
  if (prevMode == 0) {
    cardPreview.style.cursor = "grab";
    cardModeToggle0.checked = true;
  } else {
    cardModeToggle0.checked = false;
  }

}

//changes to prevDefault and prevMode from ui
export function prevModeDefault(mode) {
  prevDefault = mode;
  prevModeChange(mode);
}

function prevMod(event) {
  if (event.repeat) {
    return;
  }
  if (prevFocus && event.key == "Shift") {
    if (prevDefault != 1) {
      prevModeChange(1);
    } else {
      prevModeChange(0);
    }
  }
  if (prevFocus && event.key == "Control") {
    if (prevDefault != 2) {
      prevModeChange(2);
    } else {
      prevModeChange(0);
    }
  }
}

function prevModOff() {
  //restore to default mode
  prevModeChange(prevDefault);
}

function prevPanStart(event) {
  // console.log(event.target);
  prevMouseDown = true;

  // SPECIFICALLY listen for these, ignores other pointer events in front of it
  // hacky but i cant find a way to directly assign the target otherwise
  cardDetail.addEventListener("mousedown", function () {
    prevMouseDownTarget = cardDetail;
  }, { once: true });
  cardSig.addEventListener("mousedown", function () {
    prevMouseDownTarget = cardSig;
  }, { once: true });

  // console.log(prevMouseDownTarget);

  if (prevMode == 0) {
    cardPreview.style.cursor = "grabbing";
  }
}

function prevPanEnd(event) {
  previousTouch = undefined;
  prevMouseDown = false;
  prevMouseDownTarget = undefined;
  // previousTouch = null;
  if (prevMode == 0) {
    cardPreview.style.cursor = "grab";
  }
}

function prevPan(event) {
  //exceptions
  if (
    event.target.id == "cardZoomInput" ||
    event.target.htmlFor == "cardModeToggle0" ||
    event.target.htmlFor == "cardModeToggle1" ||
    event.target.htmlFor == "cardModeToggle2"
  ) {
    return;
  }

  // event.preventDefault();

  //touch movementX movementY hack
  if (event.touches != undefined) {
    let touch = event.touches[0];

    if (previousTouch == undefined) {
      // console.log('NEW TOUCH');
      previousTouch = event.touches[0];
    }

    event.movementX = touch.pageX - previousTouch.pageX;
    event.movementY = touch.pageY - previousTouch.pageY;
    // console.log(event.movementX + ', ' + event.movementY);
    previousTouch = touch;
  }

  if (prevMouseDown) {
    // mode 0
    if (prevMode == 0) {

      // if (prevMouseDownTarget != cardBgOutline) {
      //   return
      // }

      // console.log('panning');
      prevPanX += event.movementX * prevZoomScale;
      prevPanY += event.movementY * prevZoomScale;
      //bounds
      let boundsPan = boundsMaker(
        prevPanX,
        prevPanY,
        cardZoom.clientWidth / 2 -
        (cardPreview.clientWidth * 1) / prevZoomMin / 2,
        cardZoom.clientHeight / 2 -
        (cardPreview.clientHeight * 1) / prevZoomMin / 2,
        cardZoom.clientWidth / 2 +
        (cardPreview.clientWidth * 1) / prevZoomMin / 2 -
        cardPan.clientWidth,
        cardZoom.clientHeight / 2 +
        (cardPreview.clientHeight * 1) / prevZoomMin / 2 -
        cardPan.clientHeight
      );
      prevPanX = boundsPan.x;
      prevPanY = boundsPan.y;
      //apply
      cardPan.style.left = prevPanX + "px";
      cardPan.style.top = prevPanY + "px";
    }
    // mode 1
    if (prevMode == 1) {
      prevBgX += event.movementX * prevZoomScale;
      prevBgY += event.movementY * prevZoomScale;
      updateBg(prevBgX, prevBgY);
    }
    //mode 2
    if (prevMode == 2) {
      // detail main
      if (prevMouseDownTarget == cardDetail) {
        prevDetailX += event.movementX * prevZoomScale;
        prevDetailY += event.movementY * prevZoomScale;

        updateDetail(prevDetailX, prevDetailY);
      }

      // detail sig
      if (prevMouseDownTarget == cardSig) {
        prevSigX += event.movementX * prevZoomScale;
        prevSigY += event.movementY * prevZoomScale;
        // console.log(event.movementX + ':' + event.movementY);

        updateSig(prevSigX, prevSigY);
      }
    }
  }
}

//zoom
function prevZoom(event) {
  //stop page zoom
  if (event.ctrlKey == true) {
    event.preventDefault();
  }

  // mode 0
  if (prevMode == 0 || prevMode == 2) {
    let z = prevZoomAmt;
    if (event.deltaY > 0 && prevZoomAmt > prevZoomMin) {
      z -= prevZoomInc;
      updateZoom(z);
    }
    if (event.deltaY < 0 && prevZoomAmt < prevZoomMax) {
      z += prevZoomInc;
      updateZoom(z);
    }
  }
  // mode 1
  if (prevMode == 1) {
    let z = prevZoomAmt;
    if (event.deltaY > 0 && prevBgZoomAmt > prevBgZoomMin) {
      prevBgZoomAmt -= prevBgZoomInc;
    }
    if (event.deltaY < 0 && prevBgZoomAmt < prevBgZoomMax) {
      prevBgZoomAmt += prevBgZoomInc;
    }
    updateBgZoom(prevBgZoomAmt);
  }
}

//global update functions so its less janky to update from inputs
//fake 2 way data binding I Guess
function updatePan(x, y) { }

function updateZoom(z) {
  prevZoomAmt = z;
  prevZoomScale = 1 / prevZoomAmt;
  cardZoom.style.transform = "scale(" + prevZoomAmt + ")";
  cardZoomInput.value = Math.map(prevZoomAmt, prevZoomMin, prevZoomMax, 0, 100);
  cardZoomValue.textContent =
    Math.round(prevZoomAmt * 1000) / 10 + '%';
}

export function updateBg(x, y) {
  prevBgX = x;
  prevBgY = y;
  //apply
  cardBgTrans.style.left = prevBgX + "px";
  cardBgTrans.style.top = prevBgY + "px";
  settingsBgPosX.value = Math.round(prevBgX * 100) / 100;
  settingsBgPosY.value = Math.round(prevBgY * 100) / 100;
}

export function updateBgZoom(z) {
  prevBgZoomAmt = z;
  prevBgZoomScale = 1 / z;
  cardBgTrans.style.transform = "scale(" + z + ")";
  settingsBgPosZ.value = Math.round(z * 10000) / 100;
  // console.log(
  //     'Min:' + prevBgZoomMin + ' Max:' + prevBgZoomMax + ' Inc:' + prevBgZoomInc + '\n' +
  //     'Amt:' + prevBgZoomAmt + ' Scale:' + prevBgZoomScale
  // );
}

export function updateDetail(x, y) {
  //bounds
  let boundsPan = boundsMaker(
    x,
    y,
    0,
    0,
    card.clientWidth - cardDetail.clientWidth,
    card.clientHeight - cardDetail.clientHeight
  );
  prevDetailX = boundsPan.x;
  prevDetailY = boundsPan.y;
  //apply
  cardDetail.style.left = prevDetailX + "px";
  cardDetail.style.top = prevDetailY + "px";
  layoutPosX.value = Math.round(prevDetailX * 100) / 100;
  layoutPosY.value = Math.round(prevDetailY * 100) / 100;
}

export function updateSig(x, y) {
  //bounds
  let boundsPan = boundsMaker(
    x,
    y,
    0,
    0,
    card.clientWidth - cardSig.clientWidth,
    card.clientHeight - cardSig.clientHeight
  );
  prevSigX = boundsPan.x;
  prevSigY = boundsPan.y;
  //apply
  cardSig.style.left = prevSigX + "px";
  cardSig.style.top = prevSigY + "px";
  sigPosX.value = Math.round(prevSigX * 100) / 100;
  sigPosY.value = Math.round(prevSigY * 100) / 100;
}

export function updateSigAlign(align) {
  if (align == 0) {
    prevSigAlign = 'LEFT';
  }
  if (align == 1) {
    prevSigAlign = 'RIGHT';
  }
  if (align == 2) {
    prevSigAlign = 'CENTER';
  }
  sigAlign._x_dataStack[0].value = align;
}

//default
//0-100
updateZoom(prevZoomAmt);
cardZoomInput.addEventListener("input", () => {
  updateZoom(Math.map(cardZoomInput.value, 0, 100, prevZoomMin, prevZoomMax));
});

updateBg(prevBgX, prevBgY);
settingsBgPosX.addEventListener("input", () => {
  if (isNaN(settingsBgPosX.value) || settingsBgPosX.value == "") {
    return;
  }
  updateBg(Number(settingsBgPosX.value), prevBgY);
});
settingsBgPosY.addEventListener("input", () => {
  if (isNaN(settingsBgPosY.value) || settingsBgPosY.value == "") {
    return;
  }
  updateBg(prevBgX, Number(settingsBgPosY.value));
});

updateBgZoom(prevBgZoomAmt);
settingsBgPosZ.addEventListener("input", () => {
  if (
    isNaN(settingsBgPosZ.value) ||
    settingsBgPosZ.value == "" ||
    Number(settingsBgPosZ.value) < prevBgZoomMin * 100 ||
    Number(settingsBgPosZ.value) > prevBgZoomMax * 100
  ) {
    return;
  }
  updateBgZoom(Number(settingsBgPosZ.value) / 100);
});

updateDetail(prevDetailX, prevDetailY);
layoutPosX.addEventListener("input", () => {
  if (
    isNaN(layoutPosX.value) ||
    layoutPosX.value == "" ||
    Number(layoutPosX.value) < 0 ||
    Number(layoutPosX.value) > card.clientWidth - cardDetail.clientWidth
  ) {
    return;
  }
  updateDetail(Number(layoutPosX.value), prevDetailY);
});
layoutPosY.addEventListener("input", () => {
  if (
    isNaN(layoutPosY.value) ||
    layoutPosY.value == "" ||
    Number(layoutPosY.value) < 0 ||
    Number(layoutPosY.value) > card.clientHeight - cardDetail.clientHeight
  ) {
    return;
  }
  updateDetail(prevDetailX, Number(layoutPosY.value), prevSigAlign);
});

updateSig(prevSigX, prevSigY);
sigPosX.addEventListener("input", () => {
  if (
    isNaN(sigPosX.value) ||
    sigPosX.value == "" ||
    Number(sigPosX.value) < 0 ||
    Number(sigPosX.value) > card.clientWidth - cardSig.clientWidth
  ) {
    return;
  }
  updateSig(sigPosX.value, prevSigY);
});
sigPosY.addEventListener("input", () => {
  if (
    isNaN(sigPosY.value) ||
    sigPosY.value == "" ||
    Number(sigPosY.value) < 0 ||
    Number(sigPosY.value) > card.clientWidth - cardSig.clientWidth
  ) {
    return;
  }
  updateSig(prevSigX.value, sigPosY.value);
});
let mut = new mutResizeObserver(mutCallback);
function mutCallback(entry) {
  // console.log(entry);
  let difX = entry.prevWidth - entry.width;

  //no condition for LEFT, normal behaviour
  //RIGHT
  if (prevSigAlign == 'RIGHT') {
    prevSigX += difX;
  }
  //CENTER
  if (prevSigAlign == 'CENTER') {
    prevSigX += difX / 2;
  }

  updateSig(prevSigX, prevSigY);
}
mut.observe(cardSig);

export function saveCard() {
  document.body.style.cursor = "progress";
  // disable edit modes for proper preview
  getId("cardSaveBlock").style.display = "flex";
  prevModeChange(0);

  const options = { width: 1920, height: 1080 };

  // fuck you
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    safariDownload(card, options, 1)
  } else {
    toPng(card, options).then(function (blob) {
      saveAs(blob, "arcanumxiv.png");
      clearSaving();
    });
  }
}

function clearSaving() {
  //change back
  prevModeChange(prevDefault);
  getId("cardSaveBlock").style.display = "none";
  getId("cardShare").classList.add('show');
  document.body.style.cursor = "auto";
}

// fuck you!!!!!!
function safariDownload(card, options, attempts) {
  console.log("Trying Safari rendering, attempt #" + attempts);
  toCanvas(card, options).then(function(canvas) {
    const context = canvas.getContext('2d');
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    if (!pixelsAreEqual(imageData) || attempts >= 10) {
      renderCanvasAndSave(canvas);
      clearSaving();
    } else {
      console.log("Trying Safari rendering again...")
      setTimeout(() => (safariDownload(card, options, attempts + 1)), 1000);
    }
  });
}

function pixelsAreEqual(imageData) {
  const len = imageData.data.length;
  const topLeftPixelRgba = [imageData.data[0], imageData.data[1], imageData.data[2], imageData.data[3]];
  const bottomRightPixelRgba = [imageData.data[len - 4], imageData.data[len - 3], imageData.data[len - 2], imageData.data[len - 1]];
  console.log(topLeftPixelRgba);
  console.log(bottomRightPixelRgba);
  return (topLeftPixelRgba.every((v,i)=> v === bottomRightPixelRgba[i]));
}

function renderCanvasAndSave(canvas) {
  canvas.id = 'safariDownloadCanvas';
  document.body.appendChild(canvas);
   canvasToImage('safariDownloadCanvas', {
     name: "arcanumxiv",
     type: 'png',
     quality: 1,
   });
   document.body.removeChild(canvas);
}
